import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'thousandShort'
})
export class ThousandShortPipe implements PipeTransform {

  transform(value: number): number {
    if (!value) return 0;
    return value / 1000;
  }

}